import styled from 'styled-components';
import { Button } from '@rsos/base-components';

export const PanelHeaderRow = styled.div`
  display: flex;
  align-items: start;
  padding: 16px;
  background: ${({ theme }) => theme.colors.background};
  gap:;
`;

export const ListHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: ${({ theme }) => theme.colors.foreground};
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ListPanelContent = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const EmptyStateBox = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  border-radius: 5px;
  padding: 24px 16px;
  text-align: center;
`;

export const EmptyStatePadding = styled.div`
  padding: 16px;
`;

export const PanelHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const NewRequestButton = styled(Button)`
  height: 22px;
`;
